<template>
  <div class="modal fade" id="customerBpmSwitchModal" tabindex="-1" aria-labelledby="customerBpmSwitchModalLabel" @keydown.esc="modalHidden">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="customerBpmSwitchModalLabel">Заменить страхователя</h5>
          <button type="button" @click="modalHidden" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div v-for="insured in insureds" :key="insured.id">
            <customer-bpm-card class="border-success cursor-pointer" variant="default" :client="insured" :module="module" :mode="mode" :change-disabled="true" @click="switchInsurer(insured)"/>
          </div>
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button
              @click="modalHidden"
              type="button"
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
          >Закрыть</button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
/* global bootstrap */
// Form
// Other
import LoaderFull   from '@/components/Main/LoaderFull'
import CustomerBpmCard from '@/components/Form/Bpm/Customer/CustomerBpmCard'

export default {
  name: 'CustomerBpmSwitchModal',
  components: {
    LoaderFull,
    CustomerBpmCard,
  },
  props: {
    insureds: {
      type: Array,
      default: () => []
    },
    module: {
      type: Function,
      required: true
    },
    mode: {
      type: [Object, Function],
      required: true
    }
  },
  emits: ['switch-insurer'],
  data () {
    return {
      loader:         false,
    }
  },
  methods: {
    modalHidden() {
      const myModalEl = document.getElementById('customerBpmSwitchModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
    switchInsurer(insured) {
      this.modalHidden()
      this.$emit('switch-insurer', insured)
    }
  },
}
</script>

<style scoped>

</style>